import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const AppointedTeachers = lazy(() => import('../../container/appointment/appointedTeachers'));
const getAppointments = lazy(() => import('../../container/appointment/getAppointments'));

const AppointmentRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/appointed-teachers`} component={AppointedTeachers}/>
            <Route path={`${path}/get-appointments`} component={getAppointments}/>
        </Switch>
    );
};

export default AppointmentRoutes;